import {get, post} from "@/utils/http"

export const _selectPages = params => get("/blackList/selectPages",params);

export const _get = params => get("/blackList/get?",params);

export const _edit = params => post(params.id ? "/blackList/update" : "/blackList/save",params);

export const _updateStatus = params =>get("/blackList/updateStatus?",params);

export const _delete = params =>get("/blackList/delete?",params);
